import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import Modal from 'react-bootstrap/Modal';
class VirtualAccounts extends React.Component {
    _isMounted = false;
    state = {
        modalShow: false,
        alert: 0,
        alertMessage: '',
        selectedRow: [],
        virtualAccounts:[],
        ShowFlashMessage: false,
        FlashMessage: '',
        loading:false,
        virtualId:''
    };
    componentWillUnmount() {
        this._isMounted = false;

    }

    async componentDidMount() {
        this._isMounted = true;
        this.getAssignedVA()
    }

    async getAssignedVA(){
        let bodydata = {
            UniqeID: this.props.UniqeID,
            UserRole: this.props.selectedUserRole,
        };
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodydata,
            'profiles/getVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                if(responseData.VirtualAccounts){
                let VirtualAccounts =responseData.VirtualAccounts 
                if(VirtualAccounts && VirtualAccounts['virtualId']){   
                let IFSC='';
                let AccountNumber='';
                let UPIAddress='';
                let QRCode='';
                let virtualId='';
                
                if(VirtualAccounts && VirtualAccounts['virtualId']){
                virtualId=VirtualAccounts['virtualId']
                }
                 
                if(VirtualAccounts && VirtualAccounts['receivers']){
                    let VirtualAccountsArray = VirtualAccounts['receivers']
                 for (var i=0;i<VirtualAccountsArray.length;i++){   
                 if(VirtualAccountsArray[i].ifsc){
                    IFSC = VirtualAccountsArray[i].ifsc
                 }
                 if(VirtualAccountsArray[i].account_number){
                    AccountNumber = VirtualAccountsArray[i].account_number
                 }
                 if(VirtualAccountsArray[i].address){
                    UPIAddress = VirtualAccountsArray[i].address
                 }
                }
                }
                
                if (this._isMounted) {
                    this.setState({ virtualAccounts: [{virtualId:virtualId,IFSC:IFSC,AccountNumber:AccountNumber,UPIAddress:UPIAddress,QRCode:QRCode}] });
                }
            }
            }
                
            })

    }
    

    


    UpdateVirtualAccounts = (VirtualAccountsData) => {
        if (this._isMounted) {
            this.setState({ loading: true });
        }
        let bodydata = {
            UniqeID: this.props.UniqeID,
            VirtualAccounts: VirtualAccountsData.receivers?VirtualAccountsData.receivers:'',
            virtualId: VirtualAccountsData.virtualId?VirtualAccountsData.virtualId:'',
            UserRole: this.props.selectedUserRole,
        };
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodydata,
            'profiles/updateVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                this.getAssignedVA()

                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        alert: 2,
                        alertMessage: 'Virtual Accounts Updated...'
                    });
                }

                
            })

    }

     AddAccount= () => {

        if (this._isMounted) {
            this.setState({
                loading: true
            });
        }

        let UniqeID =this.props.UniqeID.substring(0,4)
        UniqeID = UniqeID+this.makeRandomId(4)
        let descriptor = UniqeID.padStart(12, 'S');
        //let UniqeID =this.makeRandomId(12)
        //let descriptor = UniqeID
        descriptor = descriptor.substring(0,12)
        let bodydata = {
            UniqeID: descriptor
        };
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodydata,
            'razorpay/CreateVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                if(responseData.error){
                    //console.log(responseData)
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error.description
                        });
                    }
                }
                if(responseData.receivers){
                    //console.log(responseData)
                    let receiversData = []
                    receiversData['receivers'] = responseData.receivers
                    receiversData['virtualId']= responseData.id
                    
                    this.UpdateVirtualAccounts(receiversData)
                }
                
            })
        

    }

    confirmDelete = (virtualId) => {
        if (this._isMounted) {
            this.setState({virtualId:virtualId, modalShow: true });
        }
    };
    handleClose = () => {
        if (this._isMounted) {
            this.setState({virtualId:'', modalShow: false });
        }
    };


     RemoveAccount= () => {
        if (this._isMounted) {
            this.setState({ modalShow: false });
        }
        let bodydata = {
            virtualId: this.state.virtualId
        };
        //console.log(bodydata)   
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodydata,
            'razorpay/CloseVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData)
                if(responseData.error){
                    //console.log(responseData)
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error.description
                        });
                    }
                }else{
                    this.UpdateVirtualAccounts([])
                }
            })
        

    }
    makeRandomId(length) {
        var result = '';
        var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    copyToClipboard = (rowData, FlashMessageString) => {
        
        var textField = document.createElement('textarea');
        textField.innerText = rowData;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        if (this._isMounted) {
            this.setState({
                ShowFlashMessage: true,
                FlashMessage: FlashMessageString
            });
            setTimeout(() => {
                this.setState({ ShowFlashMessage: false, FlashMessage: '' });
            }, 5000);
        }
    };
    render() {

        return (
            <Container className="no_padding">
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}
                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}


                {this.state.loading && <Spinner animation="border" />}

                
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Manage Virtual Accounts
                            </h4>
                        </Row>
                        <div>
                            <hr />
                           
                        </div>
                        {this.state.virtualAccounts.length>0 ?<MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Virtual Accounts"
                            columns={[
                                {
                                    title:'Identifier Id',
                                    field:'virtualId'
                                },
                                {
                                    title: 'IFSC',
                                    field: 'IFSC',
                                    render: (row) => (
                                        <div style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                row.IFSC,
                                                'IFSC copied to clipboard'
                                            )
                                        }>{row.IFSC} {row.IFSC &&<img className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Account #',
                                    field: 'AccountNumber',
                                    render: (row) => (
                                        <div style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                row.AccountNumber,
                                                'Account # copied to clipboard'
                                            )
                                        }>{row.AccountNumber} {row.AccountNumber &&<img className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                        </div>
                                    )
                                },
                                
                                
                                {
                                    title: 'UPI Address',
                                    field: 'UPIAddress',
                                    render: (row) => (
                                        <div style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                row.UPIAddress,
                                                'UPI Address copied to clipboard'
                                            )
                                        }>{row.UPIAddress} {row.UPIAddress &&<img className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                        </div>
                                    )
                                },
                               { title: '',
                                render: (row) => (
                                        <div>
                                        <Button
                                        variant="primary"
                                        type="submit"
                                        onClick={(e) =>
                                        this.confirmDelete(row.virtualId)
                                        }
                                        >
                                        Disabled
                                        </Button>
                                        </div>
                                    )}
                                
                            ]}
                            data={this.state.virtualAccounts}
                            //actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />:<Row style={{ justifyContent: 'center' }}>
                            <Button
                                        variant="primary"
                                        type="submit"
                                        onClick={(e) =>
                                        this.AddAccount()
                                        }
                                        >
                                        Add Account
                                        </Button>
                        </Row>}

                        <div>
                            <hr />
                           
                        </div>
                        <Form.Row>
                    
                    
                </Form.Row>

                

                <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Are you sure you want to delete?</p>
    
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        
                        <Button variant="primary" onClick={this.RemoveAccount} >
                            Yes
                        </Button>
                           
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

export default VirtualAccounts;
